// PostSignupPage.duck.js

import { addMarketplaceEntities } from '../../ducks/marketplaceData.duck';
import { fetchCurrentUser } from '../../ducks/user.duck';
import { storableError } from '../../util/errors';
import { shopperEmailData } from '../../util/customEmailData';
import { deliverCustomEmail } from '../../util/api';

// ================ Action types ================ //

export const UPDATE_USER_TYPE_REQUEST = 'app/PostSignupPage/UPDATE_USER_TYPE_REQUEST';
export const UPDATE_USER_TYPE_SUCCESS = 'app/PostSignupPage/UPDATE_USER_TYPE_SUCCESS';
export const UPDATE_USER_TYPE_ERROR = 'app/PostSignupPage/UPDATE_USER_TYPE_ERROR';

// ================ Reducer ================ //

const initialState = {
  updateInProgress: false,
  updateError: null,
  updateSuccess: false,
};

export default function postSignupPageReducer(state = initialState, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case UPDATE_USER_TYPE_REQUEST:
      return { ...state, updateInProgress: true, updateError: null, updateSuccess: false };

    case UPDATE_USER_TYPE_SUCCESS:
      return { ...state, updateInProgress: false, updateSuccess: true };

    case UPDATE_USER_TYPE_ERROR:
      return { ...state, updateInProgress: false, updateError: payload };

    default:
      return state;
  }
}

// ================ Action creators ================ //

export const updateUserTypeRequest = () => ({
  type: UPDATE_USER_TYPE_REQUEST,
});

export const updateUserTypeSuccess = () => ({
  type: UPDATE_USER_TYPE_SUCCESS,
});

export const updateUserTypeError = e => ({
  type: UPDATE_USER_TYPE_ERROR,
  error: true,
  payload: e,
});

// ================ Thunks ================ //

/**
 * Updates userType inside publicData → publicData: { userType: "farmer" | "buyer" }
 */
export const updateUserType = userType => (dispatch, getState, sdk) => {
  dispatch(updateUserTypeRequest());

  const state = getState();
  const currentUser = state.user.currentUser;

  if (!currentUser || !currentUser.id) {
    const err = new Error('No logged-in user found');
    dispatch(updateUserTypeError(err));
    return Promise.reject(err);
  }

  const nowTs = Math.floor(Date.now() / 1000);

  const oneMonthLater = new Date();
  oneMonthLater.setMonth(oneMonthLater.getMonth() + 1);
  const oneMonthLaterTs = Math.floor(oneMonthLater.getTime() / 1000);

  const activatedPlanMaybe =
    userType === 'farmiez-farmer' ? { activatedPlan: 'FREE' } : {};

  const billingCycleStartMaybe =
    userType === 'farmiez-farmer' ? { billingCycleStart: nowTs } : {};

  const billingCycleEndMaybe =
    userType === 'farmiez-farmer' ? { billingCycleEnd: oneMonthLaterTs } : {};

  return sdk.currentUser
    .updateProfile({
      publicData: {
        userType,
        ...activatedPlanMaybe,
        ...billingCycleStartMaybe,
        ...billingCycleEndMaybe
      },
    })
    .then(response => {
      dispatch(addMarketplaceEntities(response));

      // Refresh fresh updated user
      return dispatch(fetchCurrentUser())
        .then(() => {
          dispatch(updateUserTypeSuccess());
        }).then(() => {
          triggerWelcomeEmail(getState().user.currentUser, userType);
          return response;
        });
    })
    .catch(e => {
      dispatch(updateUserTypeError(storableError(e)));
      return e;
    });
};

const triggerWelcomeEmail = (user, userType) => {
  if (userType === 'farmiez-farmer') return;

  const { to, subject, text, html } = shopperEmailData({user, event: 'welcome-shopper'});

  deliverCustomEmail({ to, subject, text, html });
}

// ================ Page Load (optional placeholder) ================ //

export const loadData = () => dispatch => {
  // basic loadData placeholder if needed
  return Promise.resolve();
};
